import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { AppContext } from '../../../AppContext'; // Adjust path as needed

const Team = () => {
    const { appState } = useContext(AppContext);
    const { title, description, members } = appState.team || {};

    const settings = {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        loop: true,
        autoplay: true,
        speed: 400,
        cssEase: 'linear',
        responsive: [
            { breakpoint: 992, settings: { arrows: true, slidesToShow: 3 } },
            { breakpoint: 768, settings: { arrows: false, dots: true, slidesToShow: 2 } },
            { breakpoint: 480, settings: { arrows: false, dots: true, slidesToShow: 1 } }
        ]
    };

    if (!members?.[0]) {
        return
    }

    return (
        <section className="section-padding doctors-team-style-2 bg-gray" id={'team'}>
            <div className="container">
                <div className="section-header">
                    <div className="section-heading">
                        <h3 className="text-custom-black fw-700">{title}</h3>
                        <div className="section-description">
                            <p className="text-light-white">{description}</p>
                        </div>
                    </div>
                </div>
                <section className="section-padding bg-gray">
                    <div className="container">
                        <div className="row doctors-team-style-2">
                            {members?.slice(0, 10).map((item, i) => (
                                <div key={i} className="col-lg-3 col-md-6">
                                    <div className="team-block p-relative  mb-xl-30">
                                        <div className="inner-box">
                                            <div className="image animate-img">
                                                <img src={item.photo} alt={item.name} className="full-width" />
                                                <div className="overlay-box">
                                                    <div className="overlay-inner p-relative full-height">
                                                        <ul className="team-social-box custom">
                                                            {item.socialmedia.map((item, i) => (
                                                                <li key={i} className={item.iconclass}>
                                                                    <Link to={item.url} className={"fab fa-" + item.icon + " fs-16"} />
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="lower-content p-relative text-center">
                                                <h4><Link to="/team" className="text-custom-black fw-600 fs-20">{item.name}</Link></h4>
                                                <p className="designation text-light-white">{item.designation}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* <div className="row doctors-team darkblue">
                            {members?.slice(0, 4).map((item, i) => (
                                <div key={i} className="col-lg-3 col-md-6">
                                    <div className="doctor-item mb-xl-30">
                                        <div className="doctor-img mb-xl-20">
                                            <img src={item.photo} className="rounded-circle full-width" alt={item.name} /> <Link to="/team" className="detail-btn"><i className="fas fa-plus" /></Link>
                                        </div>
                                        <div className="doctor-content">
                                            <h6><Link to="/team" className="text-custom-black fw-700">{item.name}</Link></h6>
                                            <p className="designation text-light-white">{item.designation}</p>
                                            <ul className="custom">
                                                {item.socialmedia.map((item, i) => (
                                                    <li key={i} className={item.iconclass}>
                                                        <Link to={item.url} >
                                                            <i className={"fab fa-" + item.icon} />
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div> */}
                        {/* <div className="row doctors-team style-2">
                            {members?.slice(0, 4).map((item, i) => (
                                <div key={i} className="col-lg-3 col-md-6">
                                    <div className="doctor-item mb-md-30">
                                        <div className="doctor-img mb-xl-20">
                                            <img src={item.photo} className="full-width" alt={item.name} />
                                        </div>
                                        <div className="doctor-content">
                                            <h6><Link to="/team" className="text-custom-black fw-700"> {item.name}</Link></h6>
                                            <p className="designation text-light-white">{item.designation}</p>
                                            <ul className="custom">
                                                {item.socialmedia.map((item, i) => (
                                                    <li key={i} className={item.iconclass}>
                                                        <Link to={item.url} >
                                                            <i className={"fab fa-" + item.icon} />
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div> */}
                    </div>
                </section>
            </div>
        </section>
    );
};

export default Team;
